import User from '@/Models/User';

export default interface UpdateRecruiterDTO {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
}

export const updateRecruiterDTOFromUser = (user: User): UpdateRecruiterDTO => {
    return {
        id: user.id,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
    };
};
